import { BASE_SEPOLIA_CHAIN_ID, getContracts } from "@voidex/contracts-ts";
import { PreTGEFarmingAbi, ShipNFTAbi, ShipShopAbi, VoidTokenAbi } from "@voidex/contracts-ts";
import { erc20Abi } from "viem";

export const CHAIN_ID = BASE_SEPOLIA_CHAIN_ID;

export const contracts = getContracts(CHAIN_ID);

export const contractConfigs = {
	voidToken: {
		address: contracts.voidToken as `0x${string}`,
		abi: VoidTokenAbi,
		chainId: CHAIN_ID,
	},
	usdc: {
		address: contracts.usdc as `0x${string}`,
		abi: erc20Abi,
		chainId: CHAIN_ID,
	},
	shipNFT: {
		address: contracts.shipNFT as `0x${string}`,
		abi: ShipNFTAbi,
		chainId: CHAIN_ID,
	},
	preTgeFarming: {
		address: contracts.preTgeFarming as `0x${string}`,
		abi: PreTGEFarmingAbi,
		chainId: CHAIN_ID,
	},
	shipShop: {
		address: contracts.shipShop as `0x${string}`,
		abi: ShipShopAbi,
		chainId: CHAIN_ID,
	},
} as const;
